import * as React from "react"
import type { SVGProps } from "react"
const SvgCloudError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.5 20.71a5.3 5.3 0 0 1-3.9-1.6 5.3 5.3 0 0 1-1.6-3.9q0-1.92 1.19-3.42a5.3 5.3 0 0 1 3.06-1.93l.3-.8L2.1 5.61a1 1 0 0 1-.28-.7q0-.42.28-.7a1 1 0 0 1 .7-.27q.42 0 .7.27l17 17q.27.28.29.7a1 1 0 0 1-.29.7 1 1 0 0 1-.69.3 1 1 0 0 1-.71-.27l-1.95-1.93zm0-2h8.65L7.1 10.66l-.07.53-.03.52h-.5q-1.46 0-2.48 1.03A3.4 3.4 0 0 0 3 15.2q0 1.46 1.02 2.48A3.4 3.4 0 0 0 6.5 18.7m15.1.75-1.45-1.4A2.3 2.3 0 0 0 21 16.2q0-1.05-.72-1.77a2.4 2.4 0 0 0-1.78-.73H17v-2q0-2.07-1.46-3.53a5.1 5.1 0 0 0-4.84-1.3q-.63.16-1.2.5L8.05 5.95a7 7 0 0 1 1.86-.91A7 7 0 0 1 12 4.7q2.92 0 4.96 2.04A6.8 6.8 0 0 1 19 11.71q1.72.2 2.86 1.5a4.4 4.4 0 0 1 1.14 3 4.4 4.4 0 0 1-1.4 3.25" />
  </svg>
)
export default SvgCloudError
